export default "__VITE_ASSET__BH9pu4HX__"